<form [formGroup]="signersForm" class="w-full flex flex-column align-items-center relative">

    <!--evidence selection begin-->
    <div class="md:width-half flex flex-column align-items-center w-7 mt-4" style="text-align: center; margin: auto">
        <h3>{{ 'sipo.add-signers-component.evidence-selection-title' | translate }}</h3>
        <p>{{ 'sipo.add-signers-component.evidence-selection-content' | translate }}</p>

        <div class="flex justify-content-between pt-3 mb-6">
            <p-button
                class="w-4 mr-1 hover:bg-gray-100 pl-3 border-round-lg cursor-pointer"
                [ngClass]="{'bg-blue-100': signersForm.get('legalweight')?.value === 'basic'}"
                [label]="'sipo.simple-e-signature.short' | translate"
                (click)="controlLegalWeight('basic', false)" severity="secondary" styleClass="w-full"
                [innerHTML]="'basic' | evidenceSvg">
            </p-button>

            <p-button
                class="w-4 mx-1 pl-3 border-round-lg cursor-pointer"
                [ngClass]="{'bg-blue-100': signersForm.get('legalweight')?.value === 'basiccert',
                            'hover:bg-gray-100': userSubscription?.plan != 'Starter',
                            'hover:bg-red-100': userSubscription?.plan === 'Starter'}"
                [label]="('sipo.simple-e-signature-2.short' | translate)"
                [outlined]="signersForm.get('legalweight')?.value !== 'basiccert'"
                (click)="controlLegalWeight('basiccert', false)" severity="secondary"
                styleClass="w-full"
                [innerHTML]="'basiccert' | evidenceSvg">
            </p-button>

            <p-button
                class="w-4 mx-1 pl-3 border-round-lg cursor-pointer"
                [ngClass]="{'bg-blue-100': signersForm.get('legalweight')?.value === 'high',
                            'hover:bg-gray-100': userSubscription?.plan === PlanType.BUSINESS,
                            'hover:bg-red-100': userSubscription?.plan !== PlanType.BUSINESS}"
                [label]="'sipo.advanced-e-signature.short' | translate"
                [outlined]="signersForm.get('legalweight')?.value !== 'high'"
                (click)="controlLegalWeight('high', userSubscription?.plan != PlanType.BUSINESS)" severity="secondary"
                styleClass="w-full"
                [innerHTML]="'high' | evidenceSvg">
            </p-button>

            <p-button
                class="w-4 ml-1 pl-3 border-round-lg cursor-pointer"
                [ngClass]="{'bg-blue-100': signersForm.get('legalweight')?.value === 'max',
                            'hover:bg-gray-100': userSubscription?.plan === PlanType.BUSINESS,
                            'hover:bg-red-100': userSubscription?.plan !== PlanType.BUSINESS}"
                [label]="'sipo.qualified-e-signature.short' | translate"
                [outlined]="signersForm.get('legalweight')?.value !== 'max'"
                (click)="controlLegalWeight('max', userSubscription?.plan != PlanType.BUSINESS)" severity="secondary"
                styleClass="w-full"
                [innerHTML]="'max' | evidenceSvg">
            </p-button>
        </div>

        <!--Current plan does not include this signing type info field begin-->
        <div *ngIf="isSigningTypeCannotBeSelectedOpen"
             class="p-card mb-6 p-4 flex align-items-center gap-3 bg-yellow-50 border-1 border-yellow-300 border-round-2xl">
            <i class="pi pi-exclamation-triangle text-yellow-600 text-2xl"></i>

            <div class="flex-1">
                <p class="my-2 font-medium text-yellow-800">
                    {{ 'sipo.add-signers-component.upgrade-current-plan-message' | translate }}
                </p>
            </div>

            <button pButton
                    type="button"
                    label="{{ 'sipo.add-signers-component.upgrade-now-button' | translate }}"
                    class="p-button-sm p-button-warning"
                    (click)="navigateToPaymentPage('subscriptionPayment', false)">
            </button>
        </div>
        <!--Current plan does not include this signing type info field end-->

        <!--signing limits were out of info field begin-->
        <div *ngIf="inclusiveSignsExceeded && countFesQesSigns<=0"
             class="p-card mb-6 p-4  align-items-center gap-3 bg-yellow-50 border-1 border-yellow-300 border-round-2xl">
            <i class="pi pi-exclamation-triangle text-yellow-600 text-2xl"></i>

            <div class="flex-1">
                <p class="m-0 font-medium text-yellow-800">
                    {{ 'sipo.add-signers-component.out-of-usage-limit-message-1-part-2' | translate }}
                </p>
                <p></p>
                <p class="m-0 text-yellow-700">
                    {{ 'sipo.add-signers-component.out-of-usage-limit-message-2' | translate }}
                </p>
            </div>
            <p></p>
            <button pButton
                    type="button"
                    label="{{ 'sipo.add-signers-component.purchase-credit-button' | translate }}"
                    class="p-button-sm p-button-warning"
                    (click)="navigateToPaymentPage('creditPayment', false)">
            </button>
        </div>
        <!--signing limits were out of info field end-->
    </div>
    <!--evidence selection end-->

    <!--signers selection begin-->
    <div class="md:width-half flex flex-column align-items-center" style="text-align: center; margin: auto">
        <h3>{{ 'sipo.add-signer' | translate }}</h3>
        <p>{{ 'sipo.add-signer-info' | translate }}</p>

        <div class="flex align-items-center">
            <span class="mr-3 text-lg font-bold">{{ 'sipo.i-sign' | translate }}</span>
            <p-inputSwitch
                formControlName="iamsigning"
                (onChange)="changeEvent()"
                (click)="returnSelfSignInputSwitchDisableProperty() ? addSigner() : isLimitExceeded = false"
                >
            </p-inputSwitch>
        </div>

<!--        <div class="flex align-items-center">-->
<!--            <span class="mr-3 text-lg font-bold">{{ 'sipo.i-sign' | translate }}</span>-->
<!--            <p-inputSwitch-->
<!--                formControlName="iamsigning"-->
<!--                (onChange)="changeEvent()"-->
<!--                (click)="returnSelfSignInputSwitchDisableProperty() ? addSigner() : isLimitExceeded = false">-->
<!--            </p-inputSwitch>-->
<!--        </div>-->

        <div formArrayName="signers">
            <div
                *ngFor="let signer of signerControls; let i = index"
                [formGroup]="signer"
                class="e-mail-forms flex justify-content-between mb-2"
            >
                <app-form-element
                    [formGroup]="signer"
                    formId="fullName"
                    [formLabel]="'Name'"
                    [type]="FormTypes.TEXT"
                    class="mx-2 w-full"
                ></app-form-element>

                <app-form-element
                    [formGroup]="signer"
                    formId="email"
                    [formLabel]="'E-Mail'"
                    [type]="FormTypes.TEXT"
                    class="mx-2 w-full"
                ></app-form-element>

                <i
                    class="pi pi-trash pt-6 pl-2 text-red-300 cursor-pointer"
                    (click)="dropEmail(i)"
                ></i>
            </div>
        </div>

        <p-button *ngIf="!this.isOnlyOwnSign"
                  [label]="'sipo.add-signer-button' | translate"
                  icon="pi pi-user-plus"
                  (click)="addSigner()"
                  [style]="{ 'margin-top': '1rem' }"
                  styleClass="z-5"></p-button>

        <!--signer limit has finished info pop up begin-->
        <div *ngIf="isTotalAllowedSignerFull"
             class="fixed w-9 right-0 top-0 flex justify-content-between align-items-center">
            <div
                class="p-card w-full mb-6 p-4 flex align-items-center gap-3 bg-yellow-50 border-1 border-yellow-300 border-round-2xl">
                <i class="pi pi-exclamation-triangle text-yellow-600 text-2xl"></i>

                <div class="flex-1">
                    <p class="my-2 font-medium text-yellow-800">
                        {{ 'sipo.add-signers-component.signers-limit-full-message' | translate }}
                    </p>
                </div>

                <div>
                    <i class="pi pi-times font-bold text-2xl text-yellow-600 cursor-pointer"
                       (click)="isTotalAllowedSignerFull = false"></i>
                </div>
            </div>
        </div>
        <!--signer limit has finished info pop up end-->

    </div>
    <!--signers selection end-->
</form>
